import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import authenticationLocales from './locales';

i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': authenticationLocales.ptBr
  },
  lng: 'pt-BR',
  fallbackLng: 'pt-BR'
});

export default i18n;
